import { render, staticRenderFns } from "./shoppingGuideTaskStatistics.vue?vue&type=template&id=552a9283&scoped=true"
import script from "./shoppingGuideTaskStatistics.vue?vue&type=script&lang=js"
export * from "./shoppingGuideTaskStatistics.vue?vue&type=script&lang=js"
import style0 from "./shoppingGuideTaskStatistics.vue?vue&type=style&index=0&id=552a9283&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a9283",
  null
  
)

export default component.exports